import { useHydrated } from '@src/utils/useHydrated';
import { Button } from '@src/components/Button/Button';
import { MenuIcon } from '@src/components/icons/MenuIcon';

export interface HamburgerProps {
  open?: boolean;
  onClick: () => void;
  /** Accessible name. Defaults to English for the kit; product screens pass a translation. */
  label?: string;
  testId?: string;
}

/** Icon-only control that opens the mobile drawer. */
export function Hamburger({
  open = false,
  onClick,
  label = 'Open menu',
  testId,
}: HamburgerProps) {
  const hydrated = useHydrated();
  return (
    <Button
      variant="ghost"
      size="medium"
      icon={<MenuIcon />}
      aria-label={label}
      aria-expanded={open}
      aria-haspopup="dialog"
      disabled={!hydrated}
      onClick={onClick}
      testId={testId}
    />
  );
}
